﻿import DeviceHub from "../deviceHub";

export default {
    install(Vue, options) {
        DeviceHub.start();
        Vue.prototype.$deviceHub = DeviceHub;
    }
}